import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Row } from "reactstrap";
import styled from "styled-components";
import RenderHTML from "../../../components/RenderHTML/RenderHTML";

const RowTitle = styled.p`
  width: 100%;
  border-bottom: 1px solid #c3c3c3;
  margin-bottom: 20px;
`;

class DetailsTab extends Component {
  render() {
    const {
      details: { contact, status, notes, config },
    } = this.props;

    return (
      <Card>
        <Row form>
          <RowTitle>Notes</RowTitle>
          <RenderHTML>{notes}</RenderHTML>
        </Row>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    details: state.companyService.details,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsTab);
